module.exports = __webpack_public_path__ + "img/2023big26.348729d7.png";